import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'

interface TheoryState {
  displayMultipleChoiceTest: boolean
}

const initialState: TheoryState = {
  displayMultipleChoiceTest: false,
}

const slice = createSlice({
  name: 'theory',
  initialState,
  reducers: {
    displayMultipleChoiceTest: (state, action: PayloadAction<boolean>) => ({
      ...state,
      displayMultipleChoiceTest: action.payload,
    }),
  },
})

export const selectDisplayMultipleChoiceTest = (state: RootState): boolean => state.theory.displayMultipleChoiceTest

export const { displayMultipleChoiceTest: displayMultipleChoiceTestActionCreator } = slice.actions

export default slice.reducer
